import * as Variable from "../Stores/Variable";
import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { ApplyInstructionClient } from "../../../../../../Wrap/Api/Apply/ApplyInstruction";
import { ApplyContributionsClient } from "../../../../../../Wrap/Api/Apply/ApplyContributions";
import { ApplyModel } from "../../../../../../Wrap/Models/Models/Processes/Apply/ApplyModel";
import { AvailableProductWrappersClient } from "../../../../../../Wrap/Api/ProductWrappers/AvailableProductWrappers";
import { FullClientDetailModel } from "../../../../../../Wrap/Models/Models/Customer/FullClientDetailModel";
import { FullClientDetailClient } from "../../../../../../Wrap/Api/Customer/FullClientDetail";
import { Adviser } from "../../../../../../Wrap/Models/Domains/Adviser/Adviser";
import { AdviserDetailClient } from "../../../../../../Wrap/Api/Adviser/AdviserDetail";
import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { CedingSchemeModel } from "../../../../../../Wrap/Models/Models/Transfer/CedingSchemeModel";
import { CedingSchemeClient } from "../../../../../../Wrap/Api/Transfer/CedingScheme";
import { DrawdownInstructionClient } from "../../../../../../Wrap/Api/Drawdown/DrawdownInstruction";
import { AdviserContextDisaptcher, CustomerContextDispatcher, ProductWrapperDispatcher } from "../Stores/Variable";
import { HierarchyIdHelper } from "../../../../../Shared/Common/HierarchyIdHelper";
import { HierarchyLevelName } from "../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { ApplyWizardClient } from "../../../../../../Wrap/Api/Apply/ApplyWizard";

export class NewBusinessAction {
    public static getInstruction(instructionID: string) {
        const client = new ApplyInstructionClient();
        const promise = client.get(Number(instructionID), null);
        promise.onSuccess((data) => {
            Variable.NewBusinessDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
        });
        promise.onError((err) => {});
    }

    public static getFullClientDetailsForTheSecondCustomer(
        customerId: number,
        callBack: (data: FullClientDetailModel) => void
    ): void {
        const client = new FullClientDetailClient();
        const promise = client.get(customerId);
        promise.onSuccess((result) => {
            if (callBack) {
                this.getAdviserDetail(
                    HierarchyIdHelper.toHierarchyIdString(HierarchyLevelName.Advisor, result.ActorOwnerId)
                );
                callBack(result);
            }
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static postInstruction(from, data: ApplyModel, callback?: (error) => void) {
        let promise;
        if (from == 0 && callback) {
            callback([]);
            return;
        }

        if (from == 1) {
            const client = new ApplyInstructionClient();
            promise = client.post(data);
        } else {
            const client = new ApplyContributionsClient();
            promise = client.put(data);
        }

        promise.onSuccess((result) => {
            Variable.NewBusinessDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: result,
            });
            if (callback) {callback([]);}
        });

        promise.onError((err) => {
            Variable.NewBusinessDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static submitInstruction(data: ApplyModel, callback?: (error) => void) {
        const client = new ApplyInstructionClient();
        const promise = client.put(data);
        promise.onSuccess((result) => {
            Variable.NewBusinessDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: result,
            });
            if (callback) {callback([]);}
        });
    }

    public static cancleApplyInstruction(id, accountId, callback?: VoidFunction) {
        if (!id) {
            callback();
            return;
        }
        const client = new ApplyInstructionClient();
        const promise = client.delete(id, accountId);
        promise.onSuccess(() => {
            callback();
        });
    }

    public static cancelExistingClientWizard(wizardId, callback?: VoidFunction) {
        if (!wizardId) {
            callback();
            return;
        }
        const client = new ApplyWizardClient();
        const promise = client.delete(wizardId);
        promise.onSuccess(() => {
            callback();
        });
    }

    public static getProductWrappers(customerId: number, servicePropositionId: number) {
        const client = new AvailableProductWrappersClient();
        const promise = client.get(customerId, servicePropositionId, false);

        promise.onSuccess((data) => {
            ProductWrapperDispatcher.dispatch({
                actionType: ActionType.Update,
                payload: data,
            });
        });
        promise.onError((err) => {});
    }

    public static saveCCMDetail(customerId: number, model: FullClientDetailModel, callback) {
        const client = new FullClientDetailClient();
        const promise = client.put(customerId, model);

        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((err) => {});
    }

    public static accountHolderAction(customerId: number, callBack?: (val: FullClientDetailModel) => void) {
        const client = new FullClientDetailClient();
        const promise = client.get(customerId);

        promise.onSuccess((data) => {
            callBack(data);
        });
        promise.onError((err) => {});
    }

    public static getCustomerData(customerId: number, callBack?: (val: FullClientDetailModel) => void): void {
        const client = new FullClientDetailClient();
        const promise = client.get(customerId);

        promise.onSuccess((result) => {
            CustomerContextDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: result,
            });
            this.getAdviserDetail(
                HierarchyIdHelper.toHierarchyIdString(HierarchyLevelName.Advisor, result.ActorOwnerId)
            );
            if (callBack) {
                callBack(result);
            }
        });

        promise.onError((err) => {});
    }

    public static getAdviserDetail(hierarchyId: string, callBack?: (val: Adviser) => void): void {
        const client = new AdviserDetailClient();
        const promise = client.get(hierarchyId);

        promise.onSuccess((result) => {
            AdviserContextDisaptcher.dispatch({
                actionType: ActionType.Success,
                payload: result,
            });
            if (callBack) {
                callBack(result);
            }
        });

        promise.onError((err) => {});
    }

    public static getSpecifyCedingSchema(
        type: SubAccountType,
        partialName: string,
        callBack?: (val: CedingSchemeModel[]) => void
    ) {
        const client = new CedingSchemeClient();
        const promise = client.get(type, partialName);

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });

        promise.onError((err) => {});
    }

    public static postDrawdown(hiercharyId, model, callback) {
        const client = new DrawdownInstructionClient();
        const promise = client.post(hiercharyId, model, false);
        promise.onSuccess((result) => {
            callback(result.Result);
        });
        promise.onError((error) => {});
    }
}
